import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BillingService } from '../../../lib/services/billingService';
import { take } from 'rxjs/operators';
import { BillingInfoForm } from './billing-info.form';
import { MatSnackBar } from '@angular/material/snack-bar';

enum BillingStates {
  preview = 0,
  editing,
  loading,
}

@Component({
  selector: 'mj-billing-info',
  templateUrl: './billing-info.component.html',
  styleUrls: ['./billing-info.component.scss'],
})
export class BillingInfoComponent implements OnInit {
  state = BillingStates.preview;

  error: boolean;
  sendInvoices = true;
  billingInfo;
  unit_id;

  billingForm: FormGroup = BillingInfoForm;

  constructor(
    private billingService: BillingService,
    private snackBar: MatSnackBar,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.unit_id = localStorage.getItem('unit_id');
    this.billingService
      .fetchBillingInfo(this.unit_id)
      .pipe(take(1))
      .subscribe(billingInfo => {
        this.billingInfo = billingInfo;

        this.ref.detectChanges();
        this.assignFormValues();
      });
  }

  openEditCard() {
    this.state = BillingStates.editing;
  }

  submitBillingInfo() {
    if (!this.billingForm.valid) {
      return (this.error = true);
    }

    const request = {
      email: this.billingForm.get('email').value,
      name: this.billingForm.get('name').value,
      line1: this.billingForm.get('line1').value,
      country: this.billingForm.get('country').value,
      description: this.billingForm.get('description').value,
    };

    this.billingService
      .updateBillingInfo(this.unit_id, request)
      .pipe(take(1))
      .subscribe(
        data => {
          this.billingInfo = data;
          this.state = BillingStates.preview;
        },
        e => {
          return this.snackBar.open(e, null, {
            duration: 3000,
          });
        }
      );
  }

  toggleSendingInvoices(e) {
    this.sendInvoices = e.checked;
  }

  assignFormValues() {
    if (this.billingInfo.shipping) {
      this.billingForm
        .get('line1')
        .setValue(this.billingInfo.shipping.address.line1);
      this.billingForm
        .get('country')
        .setValue(this.billingInfo.shipping.address.country);
      this.billingForm.get('name').setValue(this.billingInfo.shipping.name);
    }
    this.billingForm.get('email').setValue(this.billingInfo.email);
    this.billingForm.get('description').setValue(this.billingInfo.description);
  }

  cancelEditing() {
    this.state = BillingStates.preview;
    this.assignFormValues();
  }
}
